import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import { DynamicListProps, Item } from "./types";
import ButtonText from "../../../../components/ButtonText";
import Icon from "../../../../components/Icon";
import { IconName } from "../../../../components/Icon/types";

import "./styles.scss";

export const DynamicList: FC<DynamicListProps> = ({
  items,
  onAdd,
  onRemove,
}) => {
  const { t } = useTranslation();
  const addIcon: IconName = "add";
  const removeIcon: IconName = "remove";

  return (
    <div className="ams-dynamic-list">
      <ul className="ams-dynamic-list__container">
        {items.map((item: Item, key: number) => {
          return (
            <li className="ams-dynamic-list__item mb-l" key={key}>
              {item}
            </li>
          );
        })}
      </ul>

      <div className="ams-dynamic-list__actions">
        <ButtonText className="mr-l" onClick={onAdd}>
          <Icon>{addIcon}</Icon>
          {t("addSKU")}
        </ButtonText>

        {items.length > 1 ? (
          <ButtonText className="ams-button--error" onClick={onRemove}>
            <Icon>{removeIcon}</Icon>
            {t("removeSKU")}
          </ButtonText>
        ) : null}
      </div>
    </div>
  );
};
